module.exports = __webpack_public_path__ + "static/media/cgLogo.872705a7.png";